function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCommentRexOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27 23V5H5v18h7.828l.586.586L16 26.172l2.586-2.586.585-.586H27zm0-20a2 2 0 012 2v18a2 2 0 01-2 2h-7l-4 4-4-4H5a2 2 0 01-2-2V5a2 2 0 012-2h22z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 11h14V9H9v2zM9 15h14v-2H9v2zM9 19h7v-2H9v2z",
    fill: props.color
  }));
}

export default SvgIconCommentRexOutline;